import React, { Component } from 'react';

class SelectCommonDefault extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { infoData, valorCombo, nombreAction, selectCombo, classSelected, selecciones, producto, isFetchingData, placeholder, haySucursal,esModificacion } = this.props
        
        let black = false
        let firstOption = {Id:0,Descripcion: placeholder ? placeholder : "Seleccione..."}
        if(nombreAction=="preEmisionId" && selecciones.preEmisionId =="0") firstOption = {Id:"Normal", Descripcion:"Normal"}
                
        
        if(nombreAction=="productoId"){ //........................................................................................... ES LA FUNCION DE PRODUCTO
            
            if((producto == null || (producto && !producto.Id))&&!esModificacion){ //........................................................................................................ NO HAY PRODUCTO SELECCIONADO
                if(infoData.length==1 && !isFetchingData && haySucursal){ //............................................................................................HAY UNA SOLA OPCION
                    selectCombo(infoData[0].Id);
                    firstOption = {Id:infoData[0].Id, Descripcion:infoData[0].Descripcion}
                }else{ //............................................................................................................. HAY MAS DE UNA OPCION
                    if(valorCombo && infoData.some((e)=>e.Id==valorCombo)){ // ........................................................HAY DEFAULT Y SE ENCUENTRA DISPONIBLE
                        let opcionDefaultEncontrada = infoData.filter((e)=>e.Id==valorCombo)[0]
                        selectCombo(opcionDefaultEncontrada.Id);
                        firstOption = {Id:opcionDefaultEncontrada.Id, Descripcion:opcionDefaultEncontrada.Descripcion}
                    }
                }
            }else{ // .................................................................................................................YA HAY UN PRODUCTO SELECCIONADO
                let productoSeleccionado = infoData.filter((p)=>p.Id==selecciones["productoId"])[0]
                if(productoSeleccionado){
                    firstOption = {Id:productoSeleccionado.Id, Descripcion:productoSeleccionado.Descripcion}
                }
            }
            
        }else{ // .....................................................................................................................NO ES PRODUCTO
            if(!selecciones[nombreAction]){ // ........................................................................................NO HAY NADA SELECCIONADO
                if(infoData.length==1){ // ............................................................................................HAY UNA SOLA OPCION
                    selectCombo(nombreAction,infoData[0].Id);
                    firstOption = {Id:infoData[0].Id, Descripcion:infoData[0].Descripcion}
                }else{ //.............................................................................................................. HAY MAS DE UNA OPCION
                    if(valorCombo && infoData.some((e)=>e.Id==valorCombo)){ //..........................................................HAY DEFAULT Y SE ENCUENTRA DISPONIBLE
                        let opcionDefaultEncontrada = infoData.filter((e)=>e.Id==valorCombo)[0]
                        selectCombo(nombreAction,opcionDefaultEncontrada.Id);
                        firstOption = {Id:opcionDefaultEncontrada.Id, Descripcion:opcionDefaultEncontrada.Descripcion}
                    }
                }
            }else{ // ..................................................................................................................YA HAY ALGO SELECCIONADO
                let opcionSeleccionadaEncontrada = infoData.filter((e)=>e.Id==selecciones[nombreAction])[0]
                if(opcionSeleccionadaEncontrada){
                    firstOption = {Id:opcionSeleccionadaEncontrada.Id, Descripcion:opcionSeleccionadaEncontrada.Descripcion}
                }else if( !opcionSeleccionadaEncontrada && infoData.length == 1){
                    selectCombo(nombreAction,infoData[0].Id);
                    firstOption = {Id:infoData[0].Id, Descripcion:infoData[0].Descripcion}
                }    
            }
        }

        if(selecciones[nombreAction] == firstOption.Id) black = true
        return (
            <div>
                <select className={"form-control default-select " + classSelected} style={ black ? {color:"black"} : null} value={selecciones[nombreAction]} onChange={(event) => {
                    const index = event.target.selectedIndex;
                    const value = event.target.options[index].value;
                    selectCombo.length>1 ? selectCombo(nombreAction, value ) : selectCombo(value);
                }}>
                    <option  key={firstOption.Id} value={firstOption.Id}>{firstOption.Descripcion}</option> 
                    {infoData.length>1 && infoData.map( (item,index) => {return <option style={{color:"black"}} key={index} value={item.Id}>{item.Descripcion}</option>} )}}
                </select>
            </div>
        );
    }
}

export default SelectCommonDefault;